var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z7cpxw8lta)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.972 16.006-.465-.399c-.64-.536-6.235-5.367-6.235-8.901a6.7 6.7 0 0 1 13.4 0c0 3.534-5.595 8.365-6.233 8.904l-.467.396zm0-14.551a5.257 5.257 0 0 0-5.25 5.25c0 2.22 3.44 5.767 5.25 7.39 1.809-1.623 5.25-5.172 5.25-7.39a5.257 5.257 0 0 0-5.25-5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.972 9.361a2.656 2.656 0 1 1 0-5.31 2.656 2.656 0 0 1 0 5.31zm0-3.983a1.328 1.328 0 1 0 0 2.656 1.328 1.328 0 0 0 0-2.656z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z7cpxw8lta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker11);
export default __webpack_public_path__ + "static/media/marker (1) 1.e82d072280b65bf1087365c3ec37195a.svg";
export { ForwardRef as ReactComponent };